<template>
  <div ref="gantt" v-if="tasks.data"></div>
</template>

<script>
import gantt from "dhtmlx-gantt";
import "../resources/js/locale_cn.js";
export default {
  name: "gantt",
  props: {
    tasks: {
      type: Object,
      default() {
        return { data: [], links: [] };
      }
    },
    myData: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  mounted: function() {
    this.getData();
    // .then(() => {
    //   this.$nextTick(() => {
    //     setTimeout(() => {
    //       this.searchBtn();
    //     }, 1000);
    //   });
    // });
  },
  methods: {
    getData() {
      // return new Promise(resolve => {
      this.osg.ajax(
        "basic/serviceAppointment/queryByServiceCrew.do",
        this.myData.params,
        res => {
          let arr = res.data;
          arr.forEach(item => {
            //服务团队
            let obj = {};
            obj.id = item._id;
            obj.text = item.orgName;
            obj.type = "project";
            obj.open = true;
            obj.color = "#74C600";
            this.tasks.data.push(obj);
            if (item.userList.length) {
              item.userList.forEach(el => {
                //服务人员
                let obj = {};
                obj.id = el._id;
                obj.text = el.name;
                obj.start_date = this.usTime(el, "createTime");
                obj.parent = item._id;
                // obj.duration = item.userList.length;
                obj.orderLength = el.serviceAppointmentList.length || 0;
                obj.type = "project";
                obj.render = "split";
                this.tasks.data.push(obj);
                if (el.serviceAppointmentList.length) {
                  //人员身上的工单
                  el.serviceAppointmentList.forEach(i => {
                    let obj = {};
                    obj.id = i._id;
                    obj.text = i.title;
                    obj.start_date = this.usTime(i, "applyTime");
                    obj.parent = el._id;
                    obj.color = "#409EFF";
                    obj.duration = 1;
                    this.tasks.data.push(obj);
                  });
                }
              });
            }
          });
          console.log(this.tasks.data);

          //反显总进度 工单比例
          let userArr = arr.map(item => {
            if (item.userList) {
              return { _id: item._id, userList: item.userList };
            }
          });
          let dataArr = userArr.map(item => {
            return {
              _id: item._id,
              serviceAppointmentList: item.userList.map(
                el => el.serviceAppointmentList.length
              )
            };
          });
          dataArr.forEach(item => {
            this.tasks.data.map(ele => {
              if (item._id == ele.id) {
                ele.serviceAppointmentList = item.serviceAppointmentList;
              }
            });
          });
          // console.log(this.tasks.data);

          // let head = document.getElementsByTagName("head")[0];
          // let script = document.createElement("script");
          // script.src = `http://export.dhtmlx.com/gantt/api.js`;
          // document.head.appendChild(script);

          gantt.config.scale_unit = "month"; //按月显示
          gantt.config.date_scale = "%Y年,%F"; //设置时间刻度的格式（X轴) 多个尺度

          // gantt.config.scale_unit = "day";
          // gantt.config.date_scale = "周%D,%d号";
          // gantt.config.duration_unit = "hour";

          // 在工作时间中计算任务持续时间时启用该模式
          gantt.config.work_time = true; // removes non-working time from calculations
          gantt.config.skip_off_time = true; // hides non-working time in the chart

          gantt.config.scale_height = 50; //设置时间刻度的高度和网格的标题
          // 在时间线上增加一行年份显示
          // gantt.config.subscales = [
          // {
          //   unit: "year",
          //   step: 1,
          //   date: "%Y年"
          // }
          // { unit: "month", step: 1, date: "%M" },
          // { unit: "hour", step: 1, date: "%H" }

          // { unit: "day", step: 1, date: "%j, %D" }
          //指定第二个时间刻度
          // ];

          // gantt.config.scale_unit = this.myData.scale_unit; //按年显示
          // gantt.config.step = this.myData.step; //设置时间刻度的步长（X轴)
          // gantt.config.date_scale = this.myData.date_scale; //日期尺度按年

          //自定义模板
          gantt.templates.task_text = (start, end, task) => {
            // return "<b>文本:</b> " + task.text;
            // console.log(start, end, task);
            //             id: "7402052469851441105"
            // text: "测侧"
            // type: "project"
            // open: true
            // debugger
            if (task.open) {
              let progress = task.serviceAppointmentList.reduce(
                (a, b) => a + b,
                0
              );
              return `共${progress}个工单，${
                !progress ? 0 : task.serviceAppointmentList.length
              }人有单，有单比例：${
                !progress ? 0 : task.serviceAppointmentList.length
              }/${this.getCount(!progress ? 0 : task.serviceAppointmentList)}`;
            } else {
              return task.text;
            }
          };
          //拖拽小方块点击事件

          // gantt.attachEvent("onTaskClick", function(id, e) {
          //   alert("You've just clicked an item with id=" + id);
          // });

          // 启用撤销功能，将config的undo参数设置为true即可：
          // gantt.config.undo = true;
          // 启用重做功能，将config的redo参数设置为true即可：
          // gantt.config.redo = true;

          //左侧显示列名
          // // gantt.config.columns = [
          //   {
          //     name: "text",
          //     label: "工单名称",
          //     tree: false,
          //     align: "center",
          //     width: 100
          //   }
          // {
          //   name: "start_date",
          //   label: "计划开始",
          //   align: "center",
          //   width: 100
          // },
          // {
          //   name: "text",
          //   label:
          //     "<div class='searchEl'>Task name <input id='search' type='text'" +
          //     "placeholder='Search tasks...'></div>",
          //   width: 250,
          //   tree: true
          // },
          // {
          //   name: "add",
          //   width: 44,
          //   min_width: 44,
          //   max_width: 44
          // }
          // { name: "haha", label: "计划结束", align: "center", width: 100 },
          // { name: "haha", label: "自定义加一列", align: "center", width: 100 }
          // ];
          // console.log(gantt.config);

          // task.render = "split";
          // gantt.render();

          // 定义从后端获取或发送到后端的日期数据解析格式
          // gantt.config.xml_date="%Y-%m-%d %H:%i";

          gantt.config.columns = [
            // {
            //   name: "text",
            //   label: textLabel,
            //   tree: true,
            //   width: "*",
            //   resize: true
            // },
            {
              name: "text",
              label:
                "<div class='searchEl'>服务人员 <input id='search' type='text'" +
                "placeholder='请输入人员名称'></div>",
              width: 250,
              tree: true
            }
            // { name: "start_date", align: "center", resize: true },
            // { name: "duration", align: "center" },
            // { name: "add", width: 44 }
          ];

          //设置周末背景色
          gantt.templates.scale_cell_class = function(date) {
            //调试器;
            if (date.getDay() == 0 || date.getDay() == 6) {
              // alert(date.getDay();
              return "weekend";
            }
          };
          gantt.templates.timeline_cell_class = function(item, date) {
            // debugger;
            if (date.getDay() == 0 || date.getDay() == 6) {
              return "weekend";
            }
          };
          //将蜡烛条开始时间和结束时间自动四舍五入 自动对齐坐标轴刻度
          // gantt.config.round_dnd_dates = false;

          //合并从ShowGannt父组件传过来的值
          Object.assign(gantt.config, this.myData.config);
          // this.getData();
          // console.log("获取数据");
          gantt.init(this.$refs.gantt); //初始化甘特图
          gantt.parse(this.$props.tasks); //载入数据
          gantt.refreshData(); //刷新数据
          // console.log(this.tasks.data);
          this.$nextTick(() => {
            setTimeout(() => {
              // console.log("初始化搜索");
              this.searchBtn();
            }, 2000);
          });
          // gantt.clearAll();  //清空甘特图（tasks)数据
          // console.log(this.tasks);
          // this.searchBtn();
          // resolve();
        }
      );
      // });
      // .then(() => {
      // this.$nextTick(() => {
      //   // setTimeout(() => {
      //   console.log("初始化搜索");
      //   this.searchBtn();
      //   // }, 2000);
      //   new Promise(resolve => {
      //     this.searchBtn();
      //     resolve();
      //   });
      // });
      // });
      // await this.searchBtn();
    },
    searchBtn() {
      // debugger;
      let inputEl = document.getElementById("search");
      inputEl.oninput = function() {
        gantt.refreshData();
      };

      function hasSubstr(parentId) {
        let task = gantt.getTask(parentId);
        if (
          task.text &&
          task.text.toLowerCase().indexOf(inputEl.value.toLowerCase()) !== -1
        )
          return true;
        let child = gantt.getChildren(parentId);
        for (let i = 0; i < child.length; i++) {
          if (hasSubstr(child[i])) return true;
        }
        return false;
      }

      gantt.attachEvent("onBeforeTaskDisplay", function(id, task) {
        if (hasSubstr(id)) return true;
        return false;
      });
    },
    //判断数组里面有多少个0
    getCount(arr) {
      if (Array.isArray(arr)) {
        let str = arr.join("");
        let n = str.split("0").length - 1;
        return !n ? arr.length : n;
      } else {
        return 0;
      }
    },
    //时间格式 yyyy-mm-dd hh:mm:ss  转为 dd-mm-yyyy ss:mm:hh
    usTime(el, dataVal) {
      let data1 = el[dataVal].substr(el[dataVal].indexOf(" ") + 1);
      data1 = data1
        .split(":")
        .reverse()
        .join(":");
      let data2 = el[dataVal].substr(0, el[dataVal].indexOf(" "));
      data2 = data2
        .split("-")
        .reverse()
        .join("-");
      return data2 + " " + data1;
    }
  },
  watch: {
    myData: {
      immediate: true,
      deep: true,
      handler: function(newVal, oldVal) {
        // console.log(newVal, oldVal);
        // this.getData();
        // gantt.clearAll();
        this.$nextTick(() => {
          Object.assign(gantt.config, this.myData.config);
          gantt.init(this.$refs.gantt); //初始化甘特图
          gantt.parse(this.$props.tasks); //载入数据
          gantt.refreshData(); //刷新数据
        });

        this.$forceUpdate();
        // console.log(newVal, oldVal);
      }
    }
  }
};
</script>

<style>
@import "~dhtmlx-gantt/codebase/dhtmlxgantt.css";
/*.gantt_task_line {
  background-color: sandybrown !important;
}
 */
.gantt_link_target .gantt_link_control div,
.gantt_task_line.gantt_drag_move .gantt_link_control div,
.gantt_task_line.gantt_drag_move .gantt_task_drag,
.gantt_task_line.gantt_drag_move .gantt_task_progress_drag,
.gantt_task_line.gantt_drag_progress .gantt_link_control div,
.gantt_task_line.gantt_drag_progress .gantt_task_drag,
.gantt_task_line.gantt_drag_progress .gantt_task_progress_drag,
.gantt_task_line.gantt_drag_resize .gantt_link_control div,
.gantt_task_line.gantt_drag_resize .gantt_task_drag,
.gantt_task_line.gantt_drag_resize .gantt_task_progress_drag,
.gantt_task_line.gantt_selected .gantt_link_control div,
.gantt_task_line.gantt_selected .gantt_task_drag,
.gantt_task_line.gantt_selected .gantt_task_progress_drag,
.gantt_task_line:hover .gantt_link_control div,
.gantt_task_line:hover .gantt_task_drag,
.gantt_task_line:hover .gantt_task_progress_drag {
  display: none;
}

.weekend {
  background: #f4f7f4;
}

.gantt_selected .weekend {
  background: #f7eb91;
}
input#search {
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  color: #606266;
  padding: 6px;
  margin-left: 6px;
}
.gantt-error {
  display: none;
}
.gantt_left_btn_set {
  display: none;
}
.gantt_cal_light {
  pointer-events: none;
}
.gantt_cancel_btn_set {
  display: block;
  pointer-events: all;
}
</style>
